<template>
  <div>
    <b-row v-if="showDebugging">
      <b-col>
        <b-row>
          <b-col cols="1">
            <label for="database">Database:</label>
          </b-col>
          <b-col>
            <b-form-select name="database" :options="databaseChoices" v-model="database" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="1">
            <label for="query">Query:</label>
          </b-col>
          <b-col>
            <b-form-textarea name="query" rows=4 v-model="query" :readonly="readonly" />
          </b-col>
        </b-row>
        <b-row>
          <h3>Arguments</h3>
        </b-row>
        <b-row v-for="(arg,ix) in args" :key="ix" class="my-1">
          <b-col>
            <b-form-input v-model="args[ix]" :readonly="readonly" />
          </b-col>
          <b-col cols="*">
            <b-btn class="mx-1" @click="upArg(ix)" :disabled="ix===0">
              <i class="fas fa-chevron-up"></i>
            </b-btn>
          </b-col>
          <b-col cols="*">
            <b-btn class="mx-1" @click="downArg(ix)" :disabled="ix===args.length-1">
              <i class="fas fa-chevron-down"></i>
            </b-btn>
          </b-col>
          <b-col cols="*">
            <b-btn variant="danger" class="mx-1" @click="removeArg(ix)">
              <i class="fas fa-trash"></i>
            </b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input @keydown.enter="addArg" v-model="newArg" />
          </b-col>
          <b-col cols="*">
            <b-btn variant="primary" class="mx-1" @click="addArg">
              <i class="fas fa-plus"></i>
            </b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-alert variant="warning" :show="limitWarning.length > 0" class="my-2">
              {{limitWarning}}
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <code v-if="queryValid">
            <span v-html="queryText" />
            <br>
          </code>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <div v-if="queryValid">
          <b-btn variant="primary" @click="submitRequest">{{ runText }}</b-btn>
          <b-btn variant="warning" @click="getCsv" v-if="showCsv">{{ csvText }}</b-btn>
        </div>
        <div v-else>
          <b-alert show variant="warning" class="mb-1">
            Query isn't valid: there were {{ query.split('?').length - 1 }} '?'s, but {{ args.length }} arguments!
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="loading">
      <b-col>
        <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert :show="error" variant="danger" class="my-2">
          An error was returned by the server! It was logged to the console.
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table :items="data" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import utility from '../../helpers/utility';
import { FingerprintSpinner } from 'epic-spinners'

export default {
  components: {
    FingerprintSpinner,
  },
  props: {
    database: { type: String, default: 'fishbowl' },
    query: { type: String, required: true },
    args: { type: Array, default: () => [] },
    showDebugging: { type: Boolean, default: false },
    showCsv: { type: Boolean, default: false },
    runText: { type: String, default: 'Submit' },
    csvText: { type: String, default: 'Get CSV' },
    readonly: { type: Boolean, default: true },
    autorun: { type: Boolean, default: false },
  },
  data() {
    return {
      databaseChoices: [
        { text: 'Fishbowl', value: 'fishbowl', mysql: true },
        { text: 'AMS2 FishionInfo', value: 'am-old-db', mysql: false },
        { text: 'AMS3 FishionInfo', value: 'ams3-fishioninfo', mysql: true },
        { text: 'CHAMP', value: 'champ', mysql: true },
        { text: 'Sales History', value: 'inventory-sales-history', mysql: true },
        { text: 'Info Settings', value: 'settings', mysql: true },
      ],
      newArg: '',
      error: false,
      loading: false,

      data: [],
    };
  },
  mounted() {
    if (this.autorun) {
      this.submitRequest()
    }
  },
  computed: {
    queryText() {
      let text = '';
      const splits = this.query.split('?');

      for (let i = 0; i < splits.length; i += 1) {
        if (i > 0) {
          text += `{ ${this.args[i-1]} }`;
        }
        text += splits[i];
      }
      return text.replaceAll('\n', '<br/>');
    },
    queryValid() {
      return this.args.length === this.query.split('?').length - 1;
    },
    limitWarning() {
      const isMysql = this.databaseChoices.filter(x => x.value === this.database)[0].mysql;
      console.log(isMysql)
      const words = this.query.trim().split(' ')
      console.log(words.length, words.at(1), words.at(2))
      if (words.length < 3) return '';

      if (isMysql) {
        if (words.at(-2).toLowerCase() !== 'limit' || isNaN(words.at(-1))) {
          return 'I really recommend setting a limit on this query!'
        } else if (Number(words.at(-1)) > 500) {
          return 'I recommend setting a smaller limit'
        }
      } else {
        if (words.at(1).toLowerCase() !== 'top' || isNaN(words.at(2))) {
          return 'I really recommend setting a limit on this query!'
        } else if (Number(words.at(2)) > 500) {
          return 'I recommend setting a smaller limit'
        }
      }
      return ''
    },
  },
  methods: {
    upArg(ix) {
      this.args = [...this.args.slice(0, ix-1), this.args[ix], this.args[ix-1], ...this.args.slice(ix+1)]
    },
    downArg(ix) {
      this.args = [...this.args.slice(0, ix), this.args[ix+1], this.args[ix], ...this.args.slice(ix+2)]
    },
    removeArg(ix) {
      this.args.splice(ix, 1);
    },
    addArg() {
      this.args.push(this.newArg);
      this.newArg = '';
    },

    async submitRequest(evt) {
      if (evt != undefined) {
        evt.preventDefault();
      }
      this.loading = true
      this.error = false

      const response = await utility.queryPassthrough(this.query, this.args, this.database);
      if (!response) {
        this.error = true
      } else {
        this.data = response
      }
      this.loading = false
    },
    async getCsv(evt) {
      if (evt != undefined) {
        evt.preventDefault();
      }
      this.error = false
      this.loading = true

      const saveData = (function () {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        return function (data, fileName) {
          const blob = new Blob([data], { type: 'octet/stream' });
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        };
      }());

      const response = await utility.queryPassthrough(this.query, this.args, this.database, true);
      if (!response) {
        this.error = true
      } else {
        saveData(response, 'file.csv');
      }
      this.loading = false
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utility/SqlQuery.vue